import { StarbaseEntity } from 'starbase-launcher';


export class QMCategoryLink extends StarbaseEntity { // TODO: This model should not inherit from StarbaseEntity.
    public qM_ManualModelUID: number;
    public specificationCategoryUID: number;
    public createdByUser: string;
    public createdDateTime: Date;
}
